module.exports = __webpack_public_path__ + "static/media/copy-dark.d01e97c4.png";